/** 모바일 기기 여부(specs/037 R-002) — 첫 진입 분기와 같은 판별 규칙을 화면 노출 조건에도 쓴다. 회전·창 크기 변화에 반응한다. */
import { useSyncExternalStore } from 'react';

import { isMobileDevice, subscribeMobileDevice } from '../lib/device';

export function useIsMobileDevice(): boolean {
  return useSyncExternalStore(subscribeMobileDevice, isMobileDevice, () => false);
}
